import { InputRoot } from './InputRoot'

export const Input = {
  Root: InputRoot,
}
